import { createContext } from 'react'
import type { VBarStackAPI } from '../types'
import { VBarStack } from './VBarStack'
import type { VBarStackContext } from './VBarStackContext'
import { useVBarStackItem } from './useVBarStackItem'

/**
 * Creates a VBar stack API that returns a hook to upsert/remove items and a parent stack
 * component to manage the items.
 *
 * This API provides type-safety over the cluster item metadata, which is used by the parent component and the hook.
 */
export function createVBarStackAPI<
  ClusterItemMetadata extends object,
>(): VBarStackAPI<ClusterItemMetadata> {
  const VBarStackContext = createContext<VBarStackContext<ClusterItemMetadata>>({
    isConnected: false,
    upsert: () => {
      // No-op
    },
    remove: () => {
      // No-op
    },
  })

  return {
    useVBarStackItem: (...params) =>
      useVBarStackItem<ClusterItemMetadata>(VBarStackContext, ...params),
    VBarStack: props => <VBarStack VBarStackContext={VBarStackContext} {...props} />,
  }
}
